import { render } from "./fullscreenIframePlayer.vue?vue&type=template&id=8008b918"
import script from "./fullscreenIframePlayer.vue?vue&type=script&lang=js"
export * from "./fullscreenIframePlayer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\medrina-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__